import classNames from 'classnames'
import Icon from 'components/Icon'
import { UI } from 'Icon/ui'
import * as React from 'react'

import './Tags.scss'

interface TagsProps {
  solid?: boolean
  children?: React.ReactNode | undefined
}

interface TagProps {
  text: string | JSX.Element
  note?: string | JSX.Element
  disabled?: boolean
  strikeThrough?: boolean
  onDelete?: () => void
}

const Tags: React.FC<TagsProps> = props => {
  const className = classNames('srprs-tags', props.solid && 'solid')
  return <div className={className}>{props.children}</div>
}

const Tag: React.FC<TagProps> = props => {
  const className = classNames(
    'srprs-tag',
    props.disabled && 'is-disabled',
    props.strikeThrough && 'is-strike-through',
  )
  return (
    <div className={className}>
      <span>
        <strong>{props.text}</strong> {props.note}
      </span>

      {props.disabled ? (
        <Icon icon={UI.lock} />
      ) : (
        <Icon icon={UI.cross} onClick={props.onDelete} />
      )}
    </div>
  )
}

Tag.defaultProps = {
  disabled: false,
}

export { Tags, Tag }
